var exports = {
  "hS": "ForwardModal.module__richInput___T3h2Z1",
  "NG": "ForwardModal.module__footerSection___T3h2Z1",
  "vm": "ForwardModal.module__messageInputContainer___T3h2Z1",
  "hj": "ForwardModal.module__messageInputContainerDisabled___T3h2Z1",
  "zt": "ForwardModal.module__messageInputContainerWithCounter___T3h2Z1",
  "pn": "ForwardModal.module__messageInputContainerWithNotice___T3h2Z1",
  "XK": "ForwardModal.module__slowmodeNotice___T3h2Z1",
  "X8": "ForwardModal.module__messageInputActions___T3h2Z1",
  "Vr": "ForwardModal.module__emojiPickerButton___T3h2Z1",
  "Z8": "ForwardModal.module__emojiPickerButtonActive___T3h2Z1",
  "mI": "ForwardModal.module__emojiIcon___T3h2Z1",
};

module.exports = exports;
